

import React from 'react';
import { Card ,Input} from 'reactstrap';
import axios from "axios";
import base_URL from "../base_URL";
import { Redirect } from "react-router-dom";
import data from "../stateData";
import { Container } from "@material-ui/core";


import { ToastContainer, toast } from "react-toastify";
  

const postThemeSuccess = () => {
    toast.success("Thank you for helping");
  };

const postThemeError = (e) => {
    toast.error(e);
  };



class Service extends React.Component {
    constructor() {
    super();
    let id=JSON.parse(localStorage.getItem("token"));
    this.state = {
      input: {},
      errors: {},
      theme:[],
      states:data,
      State:"",
      city:[],
      id
    };


     
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeState = this.changeState.bind(this);
    this.postService = this.postService.bind(this);

  }

  componentDidMount()
  {
    axios.get(`${base_URL}/theme/all`)
    
    .then(response => {
       this.setState({theme:response.data})
       
      },
      (error) => {

      }
    );
    
  }

  changeState(e)
  {
        
      let input = this.state.input;
      input[e.target.name] = e.target.value;
   
      input["city"] = "";
     
      if(e.target.value=="0")
      {
          this.setState(
        {
            "city":[] ,
            input:input     
        }
       )
     }
     else
     {
      this.setState(
          {
              "city":this.state.states.find(c=>c.state==e.target.value).districts, 
              input:input
          }
      )
        }
     
  }
    
  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({
        input
      });
  }
     
  handleSubmit(event) {
    event.preventDefault();
  
    if(this.validate()){
        console.log(this.state);
  
        let input = this.state.input;
      
        input["userId"]=this.state.id["id"]
        this.setState({input:input});
 
        this.postService(this.state.input)
    }
  }

  

  

  postService(service)
  {
    axios.post(`${base_URL}/Service/post`, service)
    
    .then(response => {

        let input = {};
        input["name"] = "";
        input["theme"]="";
        input["state"]="";
        input["city"]="";  
        input["phone"] = "";
        input["comment"] = "";
        input["userId"]="";
        this.setState({input:input});
        postThemeSuccess();

       
      },
      (error) => {
        postThemeError(error);
           
      }
    );
  };
  validate(){
      let input = this.state.input;
      let errors = {};
      let isValid = true;
  
      if (!input["name"]) {
        isValid = false;
        errors["name"] = "Please enter your name.";
      }

      if (!input["theme"] || input["theme"]=="0") {
        isValid = false;
        errors["theme"] = "Please select the Service Type";
      }

      if (!input["state"]|| input["state"]=="0") {
        isValid = false;
        errors["state"] = "Please select State ";
      }

      if (!input["city"] || input["city"]=="0") {
        isValid = false;
        errors["city"] = "Please select city ";
      }

  
    
      if (!input["phone"]) {
        isValid = false;
        errors["phone"] = "Please enter your phone number.";
      }
  
      if (typeof input["phone"] !== "undefined") {
          
        var pattern = new RegExp(/^[0-9\b]+$/);
        if (!pattern.test(input["phone"])) {
          isValid = false;
          errors["phone"] = "Please enter only number.";
        }else if(input["phone"].length != 10){
          isValid = false;
          errors["phone"] = "Please enter valid phone number.";
        }
      }
  
      if (!input["comment"]) {
        isValid = false;
        errors["comment"] = "Please enter your comment.";
      }
  
      this.setState({
        errors: errors
      });
  
      return isValid;
  }
     
  render() {
    if (localStorage.getItem("token") == null) return <Redirect to="/login" />;
    return (
        <Container  id="container">
        <Card body style={{ margin: "20px"}} id="Card" >
        <ToastContainer />
        
        <h1>Service that benefits you </h1>
        <br/>
       
        <form onSubmit={this.handleSubmit}>
  
         
          <div class="form-group">
            <label for="name">Name:</label>
            <input 
              type="text" 
              name="name" 
              value={this.state.input.name}
              onChange={this.handleChange}
              class="form-control" 
              placeholder="Enter name" 
              id="name" />
  
              <div className="text-danger">{this.state.errors.name}</div>
          </div>
  
          <div class="form-group">
            <label for="Phone">Contact:</label>
            <input 
              type="text" 
              name="phone" 
              value={this.state.input.phone}
              onChange={this.handleChange}
              class="form-control" 
              placeholder="Enter Contact Details" 
              id="phone" />
  
              <div className="text-danger">{this.state.errors.phone}</div>
          </div>
          <div class="form-group">
            <label for="theme">Service Type</label>
            <Input 
              type="select" 
              name="theme" 
              value={this.state.input.theme}
              onChange={this.handleChange}
              class="form-control" 
              placeholder="Service Type" 
              id="theme">
                 <option value="0">Select</option> 
              

                {
                    this.state.theme.map((item,id)=>
                    {
                          return (
                          <option key={id} value={item.themeName}>{item.themeName}</option>
                          );
                    })
                }  
          </Input>
              <div className="text-danger">{this.state.errors.theme}</div>
          </div>

          <div class="form-group">
            <label for="state">State</label>
            <Input 
              type="select" 
              name="state" 
              value={this.state.input.state}
              onChange={this.changeState}
              class="form-control" 
               
              id="state">
                 
                 <option value="0">Select State</option>
                {
                    this.state.states.map((item,id)=>
                    {
                          return (
                          <option key={id}>{item.state}</option>
                          );
                    })
                }  
          </Input>
              <div className="text-danger">{this.state.errors.state}</div>
          </div>
  
          <div class="form-group">
            <label for="city">City</label>
            <Input 
              type="select" 
              name="city" 
              value={this.state.input.city}
              onChange={this.handleChange}
              class="form-control" 
              id="city">
                 
                 <option value="0">Select city</option>
                {
                       
                        this.state.city
                        
                        .map((c)=>{
                            return (<option value={c}>{c}</option>);
                        })
                        
                    
                }  
          </Input>
              <div className="text-danger">{this.state.errors.city}</div>
          </div>
            
  
          <div class="form-group">
            <label for="comment">Other Information</label>
            <textarea 
              name="comment"
              value={this.state.input.comment} 
              onChange={this.handleChange}
              placeholder="Relevant Information"
              class="form-control" />
              
            
  
              <div className="text-danger">{this.state.errors.comment}</div>
          </div>
              
          <input type="submit" value="Submit" class="btn btn-success" />
        </form>
     
      </Card>
      </Container>
    );
  }
}
  

export default Service;
